
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import _WidgetsInTemplateMixin from 'dijit/_WidgetsInTemplateMixin';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MainProperties.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import aspect from 'dojo/aspect';
import date from 'dojo/date';
import stamp from 'dojo/date/stamp';
import arr from 'dojo/_base/array';
import query from 'dojo/query';
import Observable from 'dojo/store/Observable';
import Memory from 'dojo/store/Memory';
import domStyle from 'dojo/dom-style';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domAttr from 'dojo/dom-attr';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import Toaster from '../../../moreCore/UI/Toaster_TS/Toaster';
import "../../../moreCore/UI/Toaster_TS/Toaster";
import SearchPanel from '../SearchPanel/SearchPanel';
import "../SearchPanel/SearchPanel";
import DatePicker from '../DatePicker/DatePicker';
import "../DatePicker/DatePicker";
import UserProperties from '../UserProperties/UserProperties';
import "../UserProperties/UserProperties";
import moreCoreCalendar from '../../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar';
import "../../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar";
import Calendar_Buttons from '../../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons';
import "../../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons";
import SelectEntityDialog from '../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import { ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";
import methodHooks from 'more/mdsMethodHooks';


/*
import ExtendedCalendar = require("../ExtendedCalendar/ExtendedCalendar");
import "../ExtendedCalendar/ExtendedCalendar";
*/
//import SelectBox = require("../../../moreCore/UI/SelectBox/SelectBox");


interface colorAttributeRegistryObj { entity_classname: string, tmp_class_printname: string, colorAttributes: Array<WebcalendarTypes.WebCalendar_ColorAttribute> }

interface _RendererItem { Classname: string, Default_BackColor: string, Default_TextColor: string, allDay: boolean, bOverrideColoration: boolean, coloration: Array<{ ID: string, Classname: string, BackColor: string, TextColor: string }> }

interface WebCalendar_FilterDataParams {
    start: Date | string,
    end: Date | string,
    filters: Array<string>,
    cid: string,
    mode: string,
    steps: number
}
class MainProperties extends methodHooks(compose(_WidgetBaseSP, _TemplatedMixin, _WidgetsInTemplateMixin)) {
    templateString: any = template;

    ////-----------------------------nodes START
    private datePicker: MdsLax<InstanceType<typeof DatePicker>>;
    private userProperties: MdsLax<InstanceType<typeof UserProperties>>;
    private searchPanel: MdsLax<InstanceType<typeof SearchPanel>>;
    private toaster: MdsLax<InstanceType<typeof Toaster>>;
    calendar: MdsLax<InstanceType<typeof moreCoreCalendar>> = null;
    private calendarButtons: MdsLax<InstanceType<typeof Calendar_Buttons>> = null;;
    private userConfig: WebcalendarTypes.WebCalendar_Config;
    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;


    private controlContainer: HTMLElement;
    private undoAll_button: HTMLButtonElement;
    private saveChanges_button: HTMLButtonElement;
    private lockEditing_Button: HTMLButtonElement;
    private unlockEditing_Button: HTMLButtonElement;
    private controlContainerTitle: HTMLElement;
    private divSidebar: HTMLElement;
    private datePane: HTMLElement;
    private dateContainer: HTMLElement;
    private btnMobileDate: HTMLButtonElement;
    private filterPane: HTMLElement;
    private filterContainer: HTMLElement;
    private btnMobileFilter: HTMLButtonElement;
    private colorationPane: HTMLElement;
    private colorationContainer: HTMLElement;
    private colorationSelectContainer: HTMLElement;
    private btnMobileColoration: HTMLButtonElement;
    private viewOptionsPane: HTMLElement;
    private viewOptionsContainer: HTMLElement;
    private btnMobileViewOptions: HTMLButtonElement;
    private autoAdjust_container: HTMLElement;
    cbAutoAdjust: HTMLInputElement;
    private btnAutoAdjust: HTMLButtonElement;
    private data_grouping_container: HTMLElement;
    cbEnableDatagrouping: HTMLInputElement;
    cbShowEmptyGroups: HTMLInputElement;
    private btnEnableDatagrouping: HTMLButtonElement;
    private btnShowEmptyGroups: HTMLButtonElement;
    private showTimeIndicator_container: HTMLElement;
    cbShowTimeIndicator: HTMLInputElement;
    private btnShowTimeIndicator: HTMLButtonElement;
    private hideColumHeadIfNeeded_container: HTMLElement;
    cbHideColumHeadIfNeeded: HTMLInputElement;
    private btnHideColumHeadIfNeeded: HTMLButtonElement;
    private editingButtonsContainer: HTMLElement;
    cbShowEndTime: HTMLInputElement;
    private btnShowEndTime: HTMLButtonElement;
    private userPane: HTMLElement;
    private userContainer: HTMLElement;
    private btnMobileUser: HTMLButtonElement;
    private searchPane: HTMLElement;
    private calendarView_container: HTMLElement;
    private customPanesContainer: HTMLDivElement;
    private paneButtons_mobileView_container: HTMLDivElement;
    private loadingMessage: HTMLHeadingElement;

    ////-----------------------------nodes END
    //// properties ----------------------START

    private filterPaneHasCustomContent: boolean = false;
    private userPaneHasCustomContent: boolean = false;
    private colorationPaneHasCustomContent: boolean = false;
    private viewOptionsPaneHasCustomContent: boolean = false;
    private datePaneHasCustomContent: boolean = false;

    private main: any = null;
    private data: any = null;
    public params: WebCalendar_FilterDataParams = null;
    private customPanes: Array<WebcalendarTypes.WebCalendar_Pane>;
    private store: any = null;
    private baseStore: any = null;
    private calendarConfig: WebcalendarTypes.calendarConfig = null;
    private sessionData: object = null;
    private isDndEditingEnabled: boolean = false; // ob editierung als prozss überhaupt zugelassen ist
    private lastGetFilterDataReponse: any = null;
    private _getFilterDataRequest: dojo.request.Promise<any> = null;
    private refreshDisplayTimeout: number = null;
    private colorationAttrRegistry: Array<colorAttributeRegistryObj> = []; // Array<{entity_calssname: string, tmp_class_printname:string, colorAttributes : Array<colorAttributes>}>
    private itemEditChangesRegistry: Array<{ item: object }> = [];
    private editToastUUID: Function = null;
    private isEditingLocked: boolean = false; // ob der schlossknopf zu oder auf ist
    private filterCheckboxes: Array<HTMLElement> = [];
    private lastDataGroupValues: any[] = [];
    private itemClickFunction: Function;
    private gridDoubleClickFunction: Function;
    private detailviewPropertymap: Array<{ propertyname: string, label: string }> = [
    ];



    private _itemRequest: any = null;
    private __itemRequestUrl: string = "Calendar/GetItemDetails";
    private __itemRequestFunction: string = null;
    private __filterDataUrl: string = "Calendar/GetFilterData";
    private __filterDataFunction: string = null;
    private __searchSettings: any = null;
    private __displaySettings: WebcalendarTypes.WebCalendarDisplaySettings = {
        b_show_end_time: null,
        hideColumnHead: false,
        b_allow_view_2weeks: null,
        b_allow_view_3days: null,
        b_allow_view_day: null,
        b_allow_view_month: null,
        b_allow_view_week: null,
        b_show_allday_events_with_full_hours: null,
        b_show_datagroups: null,
        b_show_empty_groups: null,
        b_show_timeindicator: null
    };
    private _overrideViewMode: WebcalendarTypes.WebCalendar_ViewTypes = null;
    private _itemClickTimeout: any = null;
    private _colorationSelectList: { selects: Array<MdsLax<InstanceType<typeof SelectBox>>>, classNames: string[] };

    //UNUSED?
    //mainHeading: HTMLElement;
    //toolbar: HTMLElement;
    //showEndTime_container: HTMLElement;
    //defaultPanes: Array<WebcalendarTypes.WebCalendar_Pane>;
    //decreaseArrowNode: Array<any> = [];
    //onlyFilledGroups: Array<any> = [];
    /*
    loadingRequirements: object = {
        colorationAttributes: 0,
        filters: 0
    };
    */
    //itemOverlapPercentage: number = 50; //integer, default 


    //// properties ----------------------END

    //// methods ---------------------------START

    protected _setupSubscriptions(): void {

        let self: any = this;
        super._setupSubscriptions.apply(this, arguments as any);

         this.addSubscription("UserProperties/calendarConfig", lang.hitch(this, function (data) { this.setCalendarConfig(data) }));
        this.addSubscription("UserProperties/createCalendar", lang.hitch(this, this._createCalendar));
        this.addSubscription("UserProperties/errorLoading", lang.hitch(this, this._onErrorUserProperties));
        //this.addSubscription("ExtendedCAlendar/closeSidebar", lang.hitch(this, this._closeSidebar));
        this.addSubscription("layout/navBar_opening", lang.hitch(this, function (message) { this.onOpeningNavBar(message.sidebarWidth); }));
        this.addSubscription("layout/navBar_closing", lang.hitch(this, this.onClosingNavBar));
        this.addSubscription("itemEitGesture_end", lang.hitch(this, function (e) { this._onItemEditGesture_end(e); }));
        this.addSubscription("calendarSearchSelect/showEntity", lang.hitch(this, function (entity) { this._showCalendarEntity(entity) }));
        this.addSubscription("WebCalendar/ShowToast", lang.hitch(this, this.publishToastMessage));

        this.addSubscription("EvBooking/Saved", lang.hitch(this, this._onEditorSaved));
        this.addSubscription("EvBooking/Deleted", lang.hitch(this, this._onBookingDeleted));


        this.addSubscription("EvBookingEditor/_onEditorFormResponse", lang.hitch(this, function () {
            this.publishToastMessage(this.translate("EvBookingditor_saveData_success"), ToasterHelpers.ToasterIcons.confirmCheck)
        }));

        this.addSubscription("EvBookingEditor/_onEditorFormSaveClickNotDirty", lang.hitch(this, function () {
            this.publishToastMessage(this.translations["EvBookingditor_saveClick_notDirty"])
        }));

        // sonst warten wir darauf
        this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this._onOpenSession));
    }

    private _onErrorUserProperties(error: any) {
        //alert("Error loading user config!\r\n" + error.Message);
        this.publishToastMessage("Error loading user config!", ToasterHelpers.ToasterIcons.error, -1, error.Message)
        this.StandbyStop();
    }

    private _onOpenSession(currentSessionData: SessionData): void {

        
        
    }

    private _onEditorSaved(response) {
        //console.log("_onEditorSaved", response);
        //this.showToast({
        //    title: this.translate("EvBookingditor_saveData_success"),
        //    iconClass: toasterIcons.confirmCheck
        //});

        this.loadData();

    }

    private _onBookingDeleted(response) {
        console.log("_onBookingDeleted", response);

        this.loadData();
    }

    getCurrentSelectedCalendar(): WebcalendarTypes.WebCalendar_Config {
        if (this.userProperties) {
            return this.userProperties.currentCalendarConfig;
        }

        return null;
    }
    /**
     * Fügt einen neuen Container zur Sidebar hinzu. Wenn mobileIcon angegeben ist, wird der Container auch mobil verfügbar.
     * @param uniqueName
     * @param label
     * @param domElement
     * @param mobileIcon
     */
    addCustomPane(uniqueName: string, label: string, domElement: HTMLElement, mobileIcon?: string): void {
        if (uniqueName == null || uniqueName == "") return;

        let newContainer = this.UiModder.domConstruct.create("div",
            {
                "className": "",
                "innerHTML": "",
                "id": "cstmPane-" + uniqueName, // brauchma ggf. für addContentToPane für die Query
            }, this.customPanesContainer);

        let expandButton = this.UiModder.domConstruct.create("button",
            {
                "className": "mds-button-base mds-hover-dark button-for-max",
                "innerHTML": "<i class='fa fa-angle-right'></i>" + label
            }, newContainer);

        let contentNode = this.UiModder.domConstruct.create("div",
            {
                "className": "sidebar-div",
                "innerHTML": ""
            }, newContainer);

        let mobileButton = null;

        if (typeof (mobileIcon) == "string") {
            mobileButton = this.UiModder.domConstruct.create("button",
                {
                    "className": "w3-hide-large mds-button-base mds-hover-dark round w3-large button-for-min WebcalendarTypes.WebCalendar_paneButtons_mobileView",
                    "innerHTML": "<i class='" + mobileIcon + "'></i>"
                }, this.paneButtons_mobileView_container);

            on(mobileButton, "mouseenter", lang.hitch(this, this._setSelectedMobileDiv, uniqueName));
        }

        on(expandButton, "click", lang.hitch(this, this._toggleSidebarSection));

        let pane: WebcalendarTypes.WebCalendar_Pane = this.getCustomPaneByName(uniqueName);
        if (pane != null) {
            this.removePane(uniqueName);
        }

        pane = {
            name: uniqueName,
            rootNode: newContainer,
            buttonNode: expandButton,
            contentNode: contentNode,
            mobileButtonNode: mobileButton
        };

        this.customPanes.push(pane);

        this.addNodeToPane(uniqueName, domElement);

        if (this.customPanes.length > 0) {
            this.UiModder.domClass.remove(this.customPanesContainer, "w3-hide");
        }
    }

    removePane(name: string) {
        let index = this.getCustomPaneIndexByName(name);
        let container = this.getPaneNodeByName(name);

        // prüfen ob custom! wenn custom dann destroy, ansonsten nur hide!
        if (this.isPaneCustom(name) && index != -1) {

            let pane = this.customPanes[index];
            this.UiModder.domConstruct.destroy(pane.rootNode);

            this.customPanes.splice(index, 1);
        } else {

            container = this.getPaneNodeByName(name, true);
            if (container != null) {
                this.UiModder.domClass.add(container, "w3-hide");
            }

            let button = this.getPaneNodeByName(name, "mobile");
            if (button != null) {
                this.UiModder.domClass.add(button, "w3-disabled");
            }
        }

        if (this.customPanes.length == 0) {
            this.UiModder.domClass.add(this.customPanesContainer, "w3-hide");
        }
    }

    addNodeToPane(uniquePaneName: string, domElement: HTMLElement) {

        let container = this.getPaneNodeByName(uniquePaneName, false);

        if (container == null) return;

        if (!this.isPaneCustom(uniquePaneName)) {
            this.showPane(<WebcalendarTypes.WebCalendar_DefaultPanes>uniquePaneName);

            switch (uniquePaneName) {
                case WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane:
                    this.colorationPaneHasCustomContent = true;
                    break;

                case WebcalendarTypes.WebCalendar_DefaultPanes.datePane:
                    this.datePaneHasCustomContent = true;
                    break;
                case WebcalendarTypes.WebCalendar_DefaultPanes.filterPane:
                    this.filterPaneHasCustomContent = true;
                    break;

                case WebcalendarTypes.WebCalendar_DefaultPanes.userPane:
                    this.userPaneHasCustomContent = true;
                    break;

                case WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane:
                    this.viewOptionsPaneHasCustomContent = true;
                    break;
            }
        }

        this.UiModder.domConstruct.place(domElement, container, "last");

    }

    private showPane(name: WebcalendarTypes.WebCalendar_DefaultPanes) {
        let container = this.getPaneNodeByName(name);

        if (this.isPaneCustom(name)) {
            // die Custompane blendet sich eh selber ein oder aus wenn was drin ist...
        } else {
            container = this.getPaneNodeByName(name, true);
            this.UiModder.domClass.remove(container, "w3-hide");

            let button = this.getPaneNodeByName(name, "mobile");
            if (button != null) {
                this.UiModder.domClass.remove(button, "w3-disabled");
            }
        }
    }

    private getPaneNodeByName(name: string, bGetPaneRootContainer?: boolean | "mobile"): HTMLElement {


        if (!this.isPaneCustom(name)) {

            let node: HTMLElement = null;

            if (bGetPaneRootContainer === true) {
                node = this[name] as HTMLElement;
            }
            else if (bGetPaneRootContainer == "mobile") {
                switch (name) {
                    case WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane:
                        node = this.btnMobileColoration;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.datePane:
                        node = this.btnMobileDate;
                        break;
                    case WebcalendarTypes.WebCalendar_DefaultPanes.filterPane:
                        node = this.btnMobileFilter;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.userPane:
                        node = this.btnMobileUser;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane:
                        node = this.btnMobileViewOptions;
                        break;

                    default: node = null;
                }
            }
            else {
                switch (name) {
                    case WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane:
                        node = this.colorationContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.datePane:
                        node = this.dateContainer;
                        break;
                    case WebcalendarTypes.WebCalendar_DefaultPanes.filterPane:
                        node = this.filterContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.userPane:
                        node = this.userContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane:
                        node = this.viewOptionsContainer;
                        break;

                    default: node = null;
                }
            }

            //console.debug("webcalendar getPaneNodeByName default", name, bGetPaneRootContainer, node);

            return node;
        }

        let paneRootContainer: HTMLElement = document.getElementById("cstmPane-" + name);
        let panes = bGetPaneRootContainer === true ? [paneRootContainer] : paneRootContainer.getElementsByClassName("sidebar-div");

        //console.debug("webcalendar getPaneNodeByName custom", name, bGetPaneRootContainer, panes);

        if (panes.length == 0) return null;

        return panes[0] as HTMLElement;
    }

    private isPaneCustom(name: string): boolean {
        let index = this.getCustomPaneIndexByName(name);

        if (index != -1) return true;

        return false;
    }


    setIsDndEditingEnabled(bool: boolean): void {
        this.isDndEditingEnabled = bool;
        if (bool == true) {
            this.UiModder.domClass.remove(this.editingButtonsContainer, "w3-hide");
        } else {

            this._onClick_undoAll_button();

            this.UiModder.domClass.add(this.editingButtonsContainer, "w3-hide");

            this._onClick_unlockEditing_Button();

        }
    }

    private _setupUserProperties(): void {
        if (this.userProperties != null) {
            this.userProperties.destroy();
            this.userProperties = null;
        }
        this.userProperties = new UserProperties();

        if (this.__userPropConfig != null) {

            if (this.__userPropConfig.customFunctionName) {
                this.userProperties.addRequestParam("customFunctionName", this.__userPropConfig.customFunctionName);
            }

            if (this.__userPropConfig.requestUrl) {
                this.userProperties.setRequestUrl(this.__userPropConfig.requestUrl);
            }

            if (this.__userPropConfig.requestParams) {
                for (let param of this.__userPropConfig.requestParams) {
                    this.userProperties.addRequestParam(param.name, param.value);
                }
            }
        }

        this.UiModder.domConstruct.place(this.userProperties.domNode, this.userContainer);

        this.userProperties.startup();
    }

    private _itemClickReg: string = null;
    openDefaultDetailView(item: WebcalendarTypes.WebCalendarItemData_Default, bSuppressRequest: boolean = false) { // TODO: dive into dojo for the Item Typings

        if (item?.id == this._itemClickReg) {

            return; //
        }

        this._itemClickReg = item?.id;
        setTimeout(lang.hitch(this, function () { this._itemClickReg = null; }), 200);


        if (this.itemClickDlg != null) {
            this.itemClickDlg.destroy();
        }

        let data: WebcalendarTypes.WebcalendarItemRequestData = {
            CalendarConfigId: this.userProperties.currentCalendarConfig.ID,
            ClassName: item.Classname,
            EntityId: item.id
        }
        
        this.itemClickDlg = new GenericDialog();
        this.itemClickDlg.destroyOnClose = true;

        this.itemClickDlg.set("header", item.columnview_head_text);
        //dlg.set("content", sContentText );
        this.itemClickDlg.set("closeBtn", true);
        this.itemClickDlg._setTopCloseBtnAttr(true);
        this.itemClickDlg.closeOnEscape = true;

        this.UiModder.domStyle.set(this.itemClickDlg.textNode, "min-height", "100px");


        if (this._itemRequest != null) this._itemRequest.cancel();

        if (this.__itemRequestUrl && bSuppressRequest !== true) {

            let requestParams = {
                "jsonData": JSON.stringify(data)
            };

            if (this.__itemRequestFunction) {
                requestParams["customFunctionName"] = this.__itemRequestFunction;
            }

            this.StandbyStart(this.itemClickDlg.textNode);

            this._itemRequest = this.RequestManager.post(
                window.appRoot + this.__itemRequestUrl,
                requestParams,
                lang.hitch(this, this._onGetItemData_Response, item),
                lang.hitch(this, this._onGetItemData_Error)
            );
        }

        var sDisplayDateStart = this._convertISODateStringToLocalDateString(item.startTime);
        var sDisplayDateEnd = this._convertISODateStringToLocalDateString(item.endTime);


        let placeholdertext = "";
        if (item.columnview_body_text) {
            placeholdertext = item.columnview_body_text;
        }
        if (item.detailview_text) {
            placeholdertext = item.detailview_text;
        }
        if (placeholdertext) {
            placeholdertext = domConstruct.create("div", { className: "itemDetail", innerHTML: placeholdertext }).outerHTML;
        }
        this.itemClickDlg._setContentAttr(placeholdertext); // dann steht bis zur Response schon was drin!

        this.itemClickDlg.show();

    }

    private _onClick_undoAll_button(): void {

        this.toaster.removeAllToasts();

        if (this.lastGetFilterDataReponse) this._onGetFilterData_Response(this.lastGetFilterDataReponse);

        topic.publish("mainProperties/enableCalButtons");
        this.itemEditChangesRegistry = [];
        domAttr.set(this.undoAll_button, "disabled", true);
        domAttr.set(this.saveChanges_button, "disabled", true);

    }


    private isJSON(text) {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    }

    private _onGetItemData_Response(item: WebcalendarTypes.WebCalendarItemData_Default, response: string | object): void {

        this.StandbyStop();

        if (!response) {
            //this.itemClickDlg.close();
            //alert("response: " + response);
            return;
        }

        if (typeof (response) == "string") {
            let text = response;
            
            // prüfen ob der Text ein Objekt ist mit HTML-Content!
            let isHTML: boolean = false;
            try {
                let obj = JSON.parse(response);

                if (obj.isHTMLdetailtext) {
                    isHTML = true;
                    let div = domConstruct.create("div", { "className": "itemDetailHTML" });
                    domAttr.set(div, "innerHTML", obj.content);
                    text = div.outerHTML;
                }
            } catch (ex) {

            }

            if (!isHTML) {
                let pre = domConstruct.create("pre", { "className": "itemDetailText" });
                domAttr.set(pre, "innerHTML", response);
                text = pre.outerHTML;
            }


            this.itemClickDlg._setContentAttr(text);
        }

        else if (typeof (response) == "object") {
            
            let isHTML: boolean = false;
            let obj = <any>response;
            
            let text = obj.content;

                if (obj.isHTMLdetailtext) {
                    isHTML = true;
                    let div = domConstruct.create("div", { "className": "itemDetailHTML" });
                    domAttr.set(div, "innerHTML", obj.content);
                    text = div.outerHTML;
                }

            if (!isHTML) {
                let pre = domConstruct.create("pre", { "className": "itemDetailText" });
                //domAttr.set(pre, "innerHTML", response); <= original
                domAttr.set(pre, "innerHTML", obj.content);
                text = pre.outerHTML;
            }


            this.itemClickDlg._setContentAttr(text);
        }

    }

    private _onGetItemData_Error(Error: any) {

        this._itemRequest = null;
        //alert("Error loading item details: " + Error.Message);
        this.publishToastMessage("Error loading item details", ToasterHelpers.ToasterIcons.error, -1, Error.Message);
        //this.itemClickDlg.close(); // ? gut oder nicht so?
        this.itemClickDlg._setContentAttr(Error.Message);
        this.itemClickDlg._setHeaderAttr("Error loading item details");
        this.StandbyStop();
    }

    _convertISODateStringToLocalDateString(isoDate: string): string {
        var sYear: string = isoDate.slice(0, 4);
        var sMonth: string = isoDate.slice(5, 7);
        var sDay: string = isoDate.slice(8, 10);
        var sHour: string = isoDate.slice(11, 13);
        var sMinute: string = isoDate.slice(14, 16);
        return `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
    }

    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.warning, timeout: number = 4000, extendedMessage?: string) {

        this.editToastUUID = function () {
            return "uuid-" + ((new Date).getTime().toString(16) + Math.floor(1E7 * Math.random()).toString(16));
        }

        this.UiModder.domStyle.set(this.toaster.domNode, "z-index", 100);

        let options: toastOptions = {
            timeout: timeout,
            closeButton: true,
            ID: this.editToastUUID()
        };

        if (extendedMessage != null && typeof (extendedMessage) != "undefined") {
            options.onClick = {
                callback: lang.hitch(this, this.showErrorDetailsDlg, extendedMessage, text, null, "close", null)
            };

        }

        this.toaster.addToast(text, icon, options);
    }

    private showErrorDetailsDlg(message, header, subtitle, buttons, callback) {
        let dlg = new GenericDialog();
        dlg.show(message, header, subtitle, null, buttons, callback);
    }

    private __userPropConfig: WebcalendarTypes.WebCalendarUserPropertiesConfig = null;

    private _onClick_unlockEditing_Button(): void {

        domClass.add(this.unlockEditing_Button, "w3-hide");
        domClass.remove(this.lockEditing_Button, "w3-hide");
        this.isEditingLocked = true;
        topic.publish("set_isEditinglocked", this.isEditingLocked);

    }

    private _onClick_saveChanges_button(): void {

        this.toaster.removeAllToasts();

        //// wir clonen die itemEditChangesRegistry, weil wir dates to ISO Strins umwandeln müssen, sie aber in den Items immer noch dates bleiben müssen
        var registryClone = new Array();

        for (var registryObj of this.itemEditChangesRegistry) {
            var cloneObj = {};

            //alle referenzen zum Item loswerden
            cloneObj["item"] = (<any>Object).assign({}, registryObj["item"]);
            cloneObj["item"]["_item"] = (<any>Object).assign({}, registryObj["item"]["_item"]);
            cloneObj["item"]["startTime"] = new Date(registryObj["item"]["startTime"].getTime());
            cloneObj["item"]["endTime"] = new Date(registryObj["item"]["endTime"].getTime());

            registryClone.push(cloneObj);
        }

        ////wir müssen dates to iso strings konvertiern, damit uns die TZ nicht dazwischen spuckt
        for (let obj of registryClone) {

            obj["item"]["startTime"] = this.toStringISO(obj["item"]["startTime"]);
            obj["item"]["endTime"] = this.toStringISO(obj["item"]["endTime"]);

        }

        var data: { cid: string, changes: Array<{ item: object }> } = { cid: this.userProperties.currentCalendarConfig.ID, changes: registryClone };

        this.RequestManager.post(
            window.appRoot + "Calendar/SaveChanges",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onUpdateItemChanges_Response),
            lang.hitch(this, this._onUpdateItemChanges_Error)
        );

        topic.publish("mainProperties/enableCalButtons");
        domAttr.set(this.undoAll_button, "disabled", true);
        domAttr.set(this.saveChanges_button, "disabled", true);
    }

    _onUpdateItemChanges_Response(response: any): void {

        topic.publish("mainProperties/enableCalButtons");
        if (response == "success") {

            this.itemEditChangesRegistry = [];
            this.loadCalendarData(this.calendar._timeInterval[0], this.calendar._timeInterval[1]);

        } else {
            alert("Something went wrong: response //" + response + "//, your changes are not saved");
        }
    }

    private _onUpdateItemChanges_Error(err: any): void {
        if (err && err["Message"] != "success") {
            //alert("ERROR beim UpdateItemChanges: " + err["Message"]);
            this.publishToastMessage("error on saving changes", ToasterHelpers.ToasterIcons.error, -1, err.Message)
            console.error("error saving changes", err);
            this.StandbyStop();
            domAttr.remove(this.undoAll_button, "disabled");
            domAttr.remove(this.saveChanges_button, "disabled");
        } else if (err && err["Message"] == "success") {
            this._onUpdateItemChanges_Response(err["Message"])
        } else {
            console.error("UPDATE ERROR: ", err)
        }
    }

    loadCalendarData(start: Date, end: Date, showEmptyGroups?: boolean): void {
        this.StandbyStart(this.calendar.viewContainer); // kaputt?? warum? - RJ 2023-01-31
        //this.StandbyStart(document.getElementById("mainContent")); // nicht ideal, weil nicht zentriert wenn Sidebar sichtbar. aber bitte.
        if (this.userProperties.currentCalendarConfig == null) {
            return;
        }

        if (typeof (showEmptyGroups) == "undefined") {
            showEmptyGroups = false;
        }
        var pStart: Date = start;
        var pEnd: Date = end;

        //  zeitzonenoffset ausgleichen
        //
        if (start.getTimezoneOffset() < 0) {
            pStart = date.add(start, "minute", start.getTimezoneOffset() * (-1));
            pEnd = date.add(end, "minute", end.getTimezoneOffset() * (-1));
        }

        clearTimeout(window.queryLimitHandler);

        if (this._getFilterDataRequest != null) {
            this._getFilterDataRequest.cancel();
            this._getFilterDataRequest = null;
        }
        window.queryLimitHandler = setTimeout(lang.hitch(this, this._getFilterData, pStart, pEnd, showEmptyGroups), 1111); // durch die Animation der Oberfläche wirkt die Sekunde ok - sonst zu viele Requests beim Blättern!
    }

    private toStringISO(date: Date): string {

        return date.toISOString();
    }

    private _getFilterData(pStart: Date, pEnd: Date, showEmptyGroups?: boolean): void {
        {
            var stampOptions: object = {
                milliseconds: true,
                zulu: true
            };

            this.params = {
                start: stamp.toISOString(pStart, stampOptions),
                end: stamp.toISOString(pEnd, stampOptions),
                filters: this.get("activeFilters"),
                cid: this.userProperties.currentCalendarConfig.ID,
                mode: this.calendar.get("dateInterval"),
                steps: this.calendar.get("dateIntervalSteps")
            };


            if (this.params.mode == "month" && this.calendar.get("dateIntervalSteps") == 1) {
                this.params.start = stamp.toISOString(date.add(pStart, "week", -1), stampOptions);
                this.params.end = stamp.toISOString(date.add(pEnd, "week", 1), stampOptions);
            }

            let data = {
                start: this.params.start,
                end: this.params.end,
                filters: this.params.filters,
                cid: this.params.cid,
                mode: this.params.mode,
                steps: this.params.steps,
                showEmptyGroups: showEmptyGroups
            }

            if (this._getFilterDataRequest != null) {
                this._getFilterDataRequest.cancel();
                this._getFilterDataRequest = null;
            }

            let url = window.appRoot + this.__filterDataUrl;// "Calendar/GetFilterData";

            let params: any = {
                "jsonData": JSON.stringify(data)
            };

            if (this.__filterDataFunction != null) {
                params["customFunctionName"] = this.__filterDataFunction;
            }

            this._getFilterDataRequest = this.RequestManager.post(
                url,
                params,
                lang.hitch(this, this._onGetFilterData_Response),
                lang.hitch(this, this._onGetFilterData_Error)
            );

        }
    }

    private _onGetFilterData_Response(response: any) {
        this._getFilterDataRequest = null;

        try {
            let filterDataResponse: {
                items: Array<WebcalendarTypes.WebCalendarItemData_Default>,
                DataGroupValues: Array<any>
            };

            if (this.isJSON(response)) {
                this.lastGetFilterDataReponse = response;
                filterDataResponse = JSON.parse(response);
            } else if (response.Exception == true) {
                alert("ERROR loading filterData: details in the console")
                console.error(response);
                return;
            } else {
                filterDataResponse = response;
                this.lastGetFilterDataReponse = JSON.stringify(response);
            }

            this.data = filterDataResponse;

            // checkboxes asblenden, wenn keine datengruppen vohanden sind
            if (filterDataResponse.DataGroupValues.length) {
                domClass.remove(this.data_grouping_container, "w3-hide");
            } else {
                domClass.add(this.data_grouping_container, "w3-hide");
            }

            if (this.params.mode == "month" ||
                (this.params.mode == "week" && this.calendar.get("dateIntervalSteps") == 2)) {

                domAttr.set(this.cbAutoAdjust, 'disabled', true);
            } else {
                domAttr.set(this.cbAutoAdjust, 'disabled', false);
            }

            if (this.params.mode == "month" || (this.params.mode == "week" && this.calendar.get("dateIntervalSteps") == 2)) {
                domClass.add(this.showTimeIndicator_container, 'w3-hide');
                domClass.add(this.autoAdjust_container, 'w3-hide');
                domClass.add(this.data_grouping_container, 'w3-hide');
                domClass.add(this.hideColumHeadIfNeeded_container, 'w3-hide');

            } else {
                domClass.remove(this.showTimeIndicator_container, 'w3-hide');
                domClass.remove(this.autoAdjust_container, 'w3-hide');
                domClass.remove(this.data_grouping_container, 'w3-hide');
                domClass.remove(this.hideColumHeadIfNeeded_container, 'w3-hide');
            }

            this.baseStore = new Memory({ data: filterDataResponse });

            this.store = new Observable(this.baseStore);

            //console.log("store::: ", this.store.data)


            if (this.calendar.currentView.domNode.classList[0] == "dojoxCalendarColumnView") this.calendar.columnView.invalidateRendering();
            this.calendar.set("store", this.store);

            this.calendar.setData(this.data) //LH
            // vvv RJ: wandert direkt in den calendar vvv
            //this.calendar.calendarConfig.columnView.groups = this.data.DataGroupValues;
            //this.calendar._refreshItemsRendering();

            setTimeout(lang.hitch(this, function () {
                //this.onChange_enableDatagrouping();
                //this.onChange_showEmptyGroups();
            }), 5000);


            if (typeof this.__displaySettings.b_show_end_time != "undefined") {
                this.setShowEndTime(this.__displaySettings.b_show_end_time);
            }

            if (typeof this.cbAutoAdjust.checked != "undefined") {
                this.calendar.setAutoAdjust(this.cbAutoAdjust.checked);
            }

            //// der Kalender erlaubt die Umschaltung ja auch wenn man auf die KW oder die Tagesüberschrift klickt
            //// die Nodes suchen und disablen:
            //let config = this.userConfig;
            //let nodes = query(".dojoxCalendarRowHeaderTable", this.calendar.domNode);
            //let nodes2 = query(".dojoxCalendarColumnHeaderTable", this.calendar.domNode);

            //for (let i = 0; i < nodes.length; i++) {
            //    let elem = nodes[i] as HTMLElement;
            //    this.UiModder.domClass.toggle(elem, "noInteraction", config.b_hide_all_options === true);
            //}
            //for (let i = 0; i < nodes2.length; i++) {
            //    let elem = nodes2[i] as HTMLElement;
            //    this.UiModder.domClass.toggle(elem, "noInteraction", config.b_hide_all_options === true);
            //}


            this.StandbyStop();
        } catch (ex) {
            this.StandbyStop();
        }
    }

    private _onGetFilterData_Error(err): void { // errorCallback

        this._getFilterDataRequest = null;

        alert(err.Message);
        console.error(err);
        this.StandbyStop();
    }

    private _onClick_lockEditing_Button(): void {

        if (this.isDndEditingEnabled == true) {
            domClass.remove(this.unlockEditing_Button, "w3-hide");
            domClass.add(this.lockEditing_Button, "w3-hide");
            this.isEditingLocked = false;
            topic.publish("set_isEditinglocked", this.isEditingLocked);
        }
    }

    private _setSelectedMobileDiv(customName: string | MouseEvent, evt: MouseEvent): void {
        //console.log("_setSelectedMobileDiv: ", customName, evt)

        if (typeof (customName) == "string") {

        } else {
            evt = customName;
            customName = null;
        }

        // Alte auswahl entfernen
        var allDivs = query(".mobile-div-selected", this.divSidebar);
        allDivs.forEach(function (div) {
            domClass.remove(div, "mobile-div-selected");
        });

        let allMobileButtons = query(".button-for-min", this.divSidebar);
        allMobileButtons.forEach(function (div) {
            domClass.remove(div, "hover");
        });

        let selectedDivs;
        let sectionName: string;
        let hoveredButton: HTMLButtonElement = null;

        // Neue Auswahl hinzufügen
        if (customName) {
            let pane = this.getCustomPaneByName(<string>customName);
            if (pane) {
                //console.debug("_setSelectedMobileDiv - looking for custom pane", customName, pane);
                domClass.add(pane.mobileButtonNode, "hover");
                domClass.add(pane.contentNode, "mobile-div-selected");
            }
        }
        else if (evt && 'target' in evt) {
            if (domClass.contains(<HTMLElement>evt.target, "button-for-min")) {
                sectionName = (<HTMLElement>evt.target).dataset.section;
                hoveredButton = evt.target as HTMLButtonElement;
                domClass.add(hoveredButton, "hover");
            } else {
                sectionName = (<HTMLElement>evt.target).parentElement.dataset.section;
            }

            if (sectionName && this[sectionName]) {
                selectedDivs = query(".sidebar-div", <HTMLElement>this[sectionName]);

                if (selectedDivs) {
                    selectedDivs.forEach(function (div) {
                        domClass.add(div, "mobile-div-selected");
                    });
                }
            }

        } else {
            console.warn("'_setSelectedMobileDiv' invalid params??", evt, customName);
        }
    }

    private getCustomPaneByName(name: string): WebcalendarTypes.WebCalendar_Pane {

        let index = this.getCustomPaneIndexByName(name);

        if (index != -1) {
            return this.customPanes[index];
        }

        return null;
    }

    private getCustomPaneIndexByName(name: string): number {
        let index: number = 0;
        for (let pane of this.customPanes) {
            if (pane.name == name) {
                return index;
            }

            index++;
        }

        return -1;
    }

    private _toggleSidebarSection(node: HTMLElement | Event, condition: boolean): void {
        var content: HTMLElement;
        var button: HTMLButtonElement;

        //console.debug("_toggleSidebarSection", node, condition);

        if ('target' in node) {
            button = <HTMLButtonElement>node["target"];
            content = (<HTMLElement>query(".sidebar-div", button.parentElement)[0]);

            if (content == null) { // das ist null wenn man beim Aufklappen auf das Symbol (i-node) geklickt hat. dann muss man noch eine Ebene höher
                button = <HTMLButtonElement>button.parentElement;
                content = <HTMLElement>query(".sidebar-div", button.parentElement)[0];
            }
        } else {
            button = <HTMLButtonElement>query(".button-for-max", <HTMLElement>node)[0];
            content = <HTMLElement>query(".sidebar-div", <HTMLElement>node)[0];
        }

        domClass.toggle(button, "button-selected", condition);
        domClass.toggle(content, "show-item-div", condition);

        if (domClass.contains(button, "button-selected")) {
            var arrows = query(".fa-angle-right", button);
        } else {
            var arrows = query(".fa-angle-down", button);
        }

        for (var i = 0; i < arrows.length; i++) {
            var arrow = arrows[i];

            if (domClass.contains(button, "button-selected")) {
                domClass.remove(arrow, "fa-angle-right");
                domClass.add(arrow, "fa-angle-down");
            } else {
                domClass.remove(arrow, "fa-angle-down");
                domClass.add(arrow, "fa-angle-right");
            }
        }


        if (this.UiModder.domClass.contains(content, "show-item-div")) {
            content.parentElement.scrollIntoView({
                behavior: "smooth",
                //block: "end",
            });
        }

    }

    private toggleCb(targetCb: HTMLInputElement, targetBtn: HTMLButtonElement, targetState?: boolean, disableBtn?: boolean) {

        if (typeof targetState == "boolean") {
            targetCb.checked = targetState;
        } else {
            targetCb.checked = !targetCb.checked;
        }

        let icon = this.createFontawesomeIcon("toggle", "&nbsp;&nbsp;");
        this.UiModder.domClass.toggle(targetBtn, "secondaryBG", targetCb.checked);
        this.UiModder.domClass.toggle(targetBtn, "sL4", !targetCb.checked);
        this.UiModder.domClass.toggle(icon, "fas fa-check-circle", targetCb.checked);
        this.UiModder.domClass.toggle(icon, "far fa-circle", !targetCb.checked);

        this.UiModder.domClass.toggle(targetBtn, "w3-disabled", disableBtn === true);

        this.UiModder.domConstruct.place(icon, targetBtn.firstElementChild, "only");
    }

    private _onClick_autoAdjust(): void {
        this.toggleCb(this.cbAutoAdjust, this.btnAutoAdjust);

        this.onChange_autoAdjust();
    }
    private onChange_autoAdjust(): void {
        this.calendar.setAutoAdjust(this.cbAutoAdjust.checked)
    }

    private _onClick_enableDatagrouping(): void {
        this._setShowDatagroupsAttr(!this.cbEnableDatagrouping.checked);
    }

    private onChange_enableDatagrouping(): void {
        let value = this.cbEnableDatagrouping.checked;
        let value2 = this.cbShowEmptyGroups.checked;
        
        this.calendar.showSubColumns(value || value2, this.cbShowEmptyGroups.checked)
    }

    private _onClick_showEmptyGroups(): void {

        this._setShowEmptyGroupsAttr(!this.cbShowEmptyGroups.checked);
    }

    private onChange_showEmptyGroups(): void {
        let value = this.cbEnableDatagrouping.checked;
        let value2 = this.cbShowEmptyGroups.checked;
        
        this.calendar.showSubColumns(value || value2, this.cbShowEmptyGroups.checked)
    }

    private _onClick_showTimeIndicator(): void {

        this.toggleCb(this.cbShowTimeIndicator, this.btnShowTimeIndicator);

        this.onChange_showTimeIndicator();
    }

    private onChange_showTimeIndicator(): void {
        this.setShowTimeIndicator(this.cbShowTimeIndicator.checked);
    }

    setShowTimeIndicator(bool?: boolean, skipRendering?: boolean): void {

        this.calendar.showTimeIndicator(bool)
    }

    private _onClick_hideColumHeadIfNeeded(): void {

        this.toggleCb(this.cbHideColumHeadIfNeeded, this.btnHideColumHeadIfNeeded);

        this.onChange_hideColumHeadIfNeeded();
    }

    private onChange_hideColumHeadIfNeeded(): void {
        this.setHideColumHeadIfNeeded(this.cbHideColumHeadIfNeeded.checked);
    }

    setHideColumHeadIfNeeded(bool?: boolean, skipItemRendering?: boolean): void {
        this.calendar.setHideColumHeadIfNeeded(bool);
    }
    private _onClick_showEndTime(): void {

        this.toggleCb(this.cbShowEndTime, this.btnShowEndTime);

        this.onChange_showEndTime();
    }
    private onChange_showEndTime(): void {
        this.setShowEndTime(this.cbShowEndTime.checked);
    }

    setShowEndTime(bool?: boolean, skipItemRendering?: boolean): void {
        if (bool === true || bool == false) {
            this.__displaySettings.b_show_end_time = bool;
            //this.cbShowEndTime.checked = bool;
            this.toggleCb(this.cbShowEndTime, this.btnShowEndTime, bool);
        }

        topic.publish("MainProperties/cbShowEndTime_checked", this.__displaySettings.b_show_end_time);
        if (skipItemRendering !== true) {
            if (this.calendar) this.calendar._refreshItemsRendering();
        }
    }


    private _createCalendar(): void {

        this._toggleSidebarSection(this.userPane, true);
        this._toggleSidebarSection(this.datePane, true);

        // wichtiges Eyecandy-Zeug:
        if (this.loadingMessage) {
            domClass.remove(this.loadingMessage, "delay");
            domClass.add(this.loadingMessage, "hide");

            setTimeout(lang.hitch(this, function () {
                domConstruct.destroy(this.loadingMessage);
                this.loadingMessage = null;
            }), 1500);

        }

        let calendar: MdsLax<InstanceType<typeof moreCoreCalendar>> = new moreCoreCalendar();
        domClass.add(calendar.domNode, "mds-fade hide") // EYECANDY!
        calendar.placeAt(this.calendarView_container);

        let calendarConfig = { // DEFAULT CALENDAR CONFIG
            columnView: {
                firstDayOfWeek: 1, // 1 für montag 
                minHours: 0, // The first hour displayed by the main sheet,
                maxHours: 24, //The last hour displayed (excluded),
                selectionMode: "single", // controls the selection, this property can take the following values: “none” - no selection is possible | “single” - only one item can be selected at most | "multiple” - zero or several items can be selected.
                columnHeaderDatePattern: "EEE dd.MM.yyyy",
                groupValue: "groupValue",
            },
            matrixView: {
                labelRendererHeight: 17
            }
        }

        calendar.configureCalendar(calendarConfig);
        this.configureCalendar(calendar);
        calendar.setColumnView_bodyText_attribute("columnview_body_text");
        calendar.setColumnView_headText_attribute("columnview_head_text");
        
        calendar.showDivSubGroup = this.hasFeature("WebCalendar/NoDivSubGroup") !== true;

        //NEW LH END

        this.StandbyStop();
        this.set("calendar", calendar);

        this.emit("calendarCreated", calendar);


        domClass.remove(calendar.domNode, "hide"); // uuuund Action! (Eyecandy ist gemeint)

        //console.debug("mainproperties createcalendar", this.calendar, window.lytSidebar.isOpened);

        if (window.sidebar?.isOpened === true) {
            this.onOpeningNavBar();
        }

    }

    private checkCalendarButtonsMode(start, end): void {

        const _msPerDay = 1000 * 60 * 60 * 24;
        let diffDays = Math.floor((end - start) / _msPerDay);
        let mode;

        if (diffDays === 1) mode = WebcalendarTypes.WebCalendar_ViewModes.day;
        else if (diffDays === 3) mode = WebcalendarTypes.WebCalendar_ViewModes.threeDays;
        else if (diffDays === 7) mode = WebcalendarTypes.WebCalendar_ViewModes.week;
        else if (diffDays === 14) mode = WebcalendarTypes.WebCalendar_ViewModes.twoWeeks;
        else if (diffDays >= 28) mode = WebcalendarTypes.WebCalendar_ViewModes.month;

        let value = this.calendar.get("dateInterval");

        value == mode ? this.calendarButtons.setMode(value, false) : this.calendarButtons.setMode(mode, false);
        
    //    switch (value) {
    //        case "day":
    //            this.calendarButtons.setMode(WebcalendarTypes.WebCalendar_ViewModes.day, false);
    //            break;
    //        case "week":
    //            this.calendarButtons.setMode(WebcalendarTypes.WebCalendar_ViewModes.week, false);
    //        default:
    //    }
    }

    private onClosingNavBar(sidebarWidth?: string): void {

        if (this.calendar && this.calendar.mainContainer) {
            if (typeof (sidebarWidth) == "undefined") {
                sidebarWidth = window.sidebar.collapsedWidth;
            }
            this.calendar.mainContainer.style["margin-left"] = sidebarWidth ? sidebarWidth : "0px";

            setTimeout(lang.hitch(this, function () {
                this.calendar._refreshItemsRendering();
            }), 400);
        }
    }
    private onOpeningNavBar(sidebarWidth?: string): void { //sidebarWidth:  string mit "px" am ende

        if (typeof (sidebarWidth) == "undefined") {
            sidebarWidth = window.sidebar.sidebarWidth;
        }

        if (this.calendar && this.calendar.mainContainer) {
            document.getElementById("darkenOverlay").style.display = "none";
            this.calendar.mainContainer.style["margin-left"] = sidebarWidth;

            setTimeout(lang.hitch(this, function () {
                this.calendar._refreshItemsRendering();
            }), 400);
        }

        this._setSelectedMobileDiv("xx-none-xx", null);
    }

    private buttonsToAdd: Array<WebcalendarTypes.WebCalender_ViewButton>;
    addTopButton(name: string, label: string, clickFct: Function, showAsButton: boolean, showInViewMenu: boolean, iconClass?: string) {
        this.buttonsToAdd.push({
            name: name,
            label: label,
            function: clickFct,
            nodeName: "",
            iconClass: iconClass,
            showInViewMenu: showInViewMenu,
            showAsButton: showAsButton
        });
        this.createMissingTopButtons();
    }

    private createMissingTopButtons(): void {
        if (this.calendarButtons) {
            for (let entry of this.buttonsToAdd) {
                this.calendarButtons.addButton(entry);
            }

            this.buttonsToAdd = [];
        }
    }
    private configureCalendar(calendar: MdsLax<InstanceType<typeof moreCoreCalendar>>): void {

        
        this.configureButtons();

        this.createMissingTopButtons();

        let topBar = document.getElementById("topBar_layout");
        topic.subscribe("set_isEditinglocked", lang.hitch(this, function (isEditingLocked) { this.isEditingLocked = isEditingLocked; }));
        if (topBar) {
            domAttr.set(calendar.mainContainer, "style", "margin-top: calc(-1px + " + topBar.offsetHeight + "px) !important;");

        } else {
            alert("set the window.topBar_height first");
        }

        this.datePicker.set("value", calendar.get("date"));
        var updateDatePicker: Function = lang.hitch(this, function (startTime: Date, endTime: Date) {

            this.datePicker.set("currentFocus", startTime, false);
            this.datePicker.set("minDate", startTime);
            this.datePicker.set("maxDate", endTime);
            this.datePicker._populateGrid();
            domStyle.set(this.datePane, "display", "block");
        });

        aspect.after(this, "loadData", lang.hitch(this, function () {
            if (this.calendar._timeInterval) {
                this.loadCalendarData(this.calendar._timeInterval[0], calendar._timeInterval[1]);
            }
        }));


        aspect.after(calendar.columnView, "invalidateRendering", lang.hitch(this, function () {
            this.scrollToFirstVisibleItem(lang.clone(calendar.storeManager.items));
            calendar.resizeColumnViewHours();
        }));

        calendar.setItemClickFunction(lang.hitch(this, this.itemClickFunction));

        /*
        calendar.on("itemClick", lang.hitch(this, function (eventArgs) {
            if (this._itemClickTimeout != null) {
                return;
            }

            this._itemClickTimeout = setTimeout(lang.hitch(this, function (callbackName: string, callbackArguments: any, handleNme: string) {
                this[callbackName](callbackArguments);
                this[handleNme] = null;
            }), 13, "itemClickFunction", eventArgs.item, "_itemClickTimeout");
        }));
        */
        calendar.on("gridDoubleClick", lang.hitch(this, this._onGridDoubleClick));

        // configure item properties panel
        calendar.on("timeIntervalChange", lang.hitch(this, function (args) {
            this.loadCalendarData(args.startTime, args.endTime);
            updateDatePicker(args.startTime, args.endTime);
            var von: string = args.startTime.getDate() + "." + (args.startTime.getMonth() + 1) + "." + args.startTime.getFullYear();
            var bis: string = args.endTime.getDate() + "." + (args.endTime.getMonth() + 1) + "." + args.endTime.getFullYear();

            if ((args.endTime.getTime() - args.startTime.getTime()) == 86400000) {
                this.controlContainerTitle.innerHTML = von;
            } else {
                this.controlContainerTitle.innerHTML = von + " - " + bis;
            }

            this.checkCalendarButtonsMode(args.startTime, args.endTime);
        }));
    }

    private _onViewChange(view: string) {
        
        switch (view) {
            case "day":
                this.calendar.dayButtonClick();
                break;

            case "3days":
                this.calendar.set("dateIntervalSteps", 3);
                this.calendar.set("dateInterval", "day");
                break;

            case "week":
                this.calendar.weekButtonClick();
                break;

            case "2weeks":
                this.calendar.set("dateIntervalSteps", 2);
                this.calendar.set("dateInterval", "week");
                break;

            case "month":
                this.calendar.monthButtonClick();
                break;

            case "next":
                this.calendar.nextRange();
                break;

            case "previous":
                this.calendar.previousRange();
                break;

            case "today":
                this.calendar.todayButtonClick();
                this.calendarButtons.setMode(WebcalendarTypes.WebCalendar_ViewModes.day, false);
                break;
        }
    }

    private configureButtons() {
        if (!this.calendarButtons) {
            this.calendarButtons = new Calendar_Buttons();
            let topBar_item_right = document.getElementById("mainMenuGlobalSpace");
            this.calendarButtons.placeAt(topBar_item_right);

            this.calendarButtons.on("viewChange", lang.hitch(this, this._onViewChange));

        }

        if (this.userConfig) {
            let config = this.userConfig;

            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.day, config.b_allow_view_day);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.threeDays, config.b_allow_view_3days);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.week, config.b_allow_view_week);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.twoWeeks, config.b_allow_view_2weeks);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.month, config.b_allow_view_month);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDetail, false); // im alten Kalender nicht verfügbar
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineOverview, false); // im alten Kalender nicht verfügbar
            
            //this.calendarButtons.allowView("timeline", config.b_allow_view_timeline);
        }
    }

    private _onGridDoubleClick(evtArgs): void {
        if (typeof (this.gridDoubleClickFunction) == "function") {
            this.gridDoubleClickFunction(evtArgs.date)
        }
    }

    private scrollToFirstVisibleItem(items: Array<any>): void {
        if (items && items.length) {

            // zum ersten item scrollen
            var firstTitemOfVisibleRange: { startTime: Date } = this.calendar.getFirstItemOfCurrentVisibleRange(items);
            if (firstTitemOfVisibleRange != null) {
                this.calendar.currentView.set("startTimeOfDay", { hours: firstTitemOfVisibleRange.startTime.getHours(), duration: 1000 });
            } else {
                // wenn items vorhanden sind, aber keines anzuzeigen ist, dann zu 08:00 scrollen
                this.calendar.currentView.set("startTimeOfDay", { hours: 8, duration: 1000 });
            }

        } else {
            // wenn keine items vorhanden sind, dann zu 08:00 scrollen
            this.calendar.currentView.set("startTimeOfDay", { hours: 8, duration: 1000 });
        }
    }

    setCalendarConfig(data: WebcalendarTypes.WebCalendar_Config): void {

        var config: WebcalendarTypes.WebCalendar_Config = data;
        this.userConfig = data;

        if (!config) return;

        //this.userConfig.b_allow_view_timeline = false; // alte MainProperties unterstützen keine Timeline

        // coloration-Attributes zusammenstellen:
        let colors: Array<WebcalendarTypes.WebCalendar_ColorAttribute> = [];
        for (let htColor of config.ref_web_calendar.EL_ht_web_calendar_colorattribute_web_calendar) {
            colors.push(htColor.ref_web_calendar_colorattribute);
        }

        this.setIsDndEditingEnabled(config["is_dnd_editing_enabled"])

        this._setColorationAttributesAttr(colors);
        this._setFiltersAttr(config.ref_web_calendar.EL_ht_web_calendar_filter_web_calendar);


        this.configureButtons();

        // nur setzen, wenn es nicht von außerhalb irgendwie übersteuert ist?!
        if (this._overrideViewMode == null) {
            this.setDefaultView(config.default_view);
        }


        this._setShowEmptyGroupsAttr(config.b_show_empty_groups);
        this._setShowDatagroupsAttr(config.b_show_datagroups);

        // einmal Styles rechnen:
        //this.toggleCb(this.cbShowEmptyGroups, this.btnShowEmptyGroups, this.cbShowEmptyGroups.checked); // wird schon übers Set gemacht
        //this.toggleCb(this.cbEnableDatagrouping, this.btnEnableDatagrouping, this.cbEnableDatagrouping.checked); // wird schon übers Set gemacht
        this.toggleCb(this.cbShowEndTime, this.btnShowEndTime, this.cbShowEndTime.checked);
        this.toggleCb(this.cbAutoAdjust, this.btnAutoAdjust, this.cbAutoAdjust.checked);
        this.toggleCb(this.cbShowTimeIndicator, this.btnShowTimeIndicator, this.cbShowTimeIndicator.checked);
        this.toggleCb(this.cbHideColumHeadIfNeeded, this.btnHideColumHeadIfNeeded, this.cbHideColumHeadIfNeeded.checked);

        if (config.b_hide_all_options === true) {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane);
        }
        else {
            this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane);
        }


        if (config.b_hide_coloration === true) {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);
        }
        else {
            this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);
        }

        //this.setShowEndTime(config.b_show_end_time, true);

        this.setShowTimeIndicator(config.b_show_timeindicator);

        this.setHideColumHeadIfNeeded(this.__displaySettings.hideColumnHead, true);

        this._overrideViewMode = null;
        this.loadCalendarData(this.calendar._timeInterval[0], this.calendar._timeInterval[1]);
    }

    //??

    private _setDefaultViewAttr(sDefaultView: string) {
        // dojo-setter
        this.setDefaultView(sDefaultView);
    }
    private setDefaultView(sDefaultView: string) {

        var sExpectedDateInterval = "week";
        var iExpectedDateIntervalSteps = 1;
        let viewName = "week";
        let viewMode: WebcalendarTypes.WebCalendar_ViewModes;

        // falls es übersetzt und nicht als Value aus der DB kommt...
        switch (sDefaultView.toLowerCase()) {
            case "monat":
                sDefaultView = "MONTH";
                break;
            case "woche":
                sDefaultView = "WEEK";
                break;
            case "tag":
                sDefaultView = "DAY";
                break;
            case "3 tage":
                sDefaultView = "THREEDAYS";
                break;
        }

        switch (sDefaultView) {
            case "WEEK":
            case "MONTH":
            case "DAY":
                sExpectedDateInterval = sDefaultView.toLowerCase();
                iExpectedDateIntervalSteps = 1;
                viewName = sDefaultView.toLowerCase();
                viewMode = viewName as any;
                break;
            case "THREEDAYS":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.threeDays;
                sExpectedDateInterval = "day";
                iExpectedDateIntervalSteps = 3;
                viewName = "3days";
                break;
            case "TWOWEEKS":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.twoWeeks;
                sExpectedDateInterval = "week";
                iExpectedDateIntervalSteps = 2;
                viewName = "2weeks";
                break;
        }

        if (sExpectedDateInterval != this.calendar.get("dateInterval")) {
            this.calendar.set("dateInterval", sExpectedDateInterval);
        }

        if (iExpectedDateIntervalSteps != this.calendar.get("dateIntervalSteps")) {
            this.calendar.set("dateIntervalSteps", iExpectedDateIntervalSteps);
        }

        if (this.calendarButtons) {
            this.calendarButtons.setCurrentView(viewMode);
        }
    }

    private _setShowDatagroupsAttr(bShowDatagroups: boolean) {
        
        this.toggleCb(this.cbEnableDatagrouping, this.btnEnableDatagrouping, bShowDatagroups || this.cbShowEmptyGroups.checked, this.cbShowEmptyGroups.checked);

        this.onChange_enableDatagrouping();
    }

    private _setShowEmptyGroupsAttr(bShowEmptyGroups: boolean) {
        
        this.toggleCb(this.cbShowEmptyGroups, this.btnShowEmptyGroups, bShowEmptyGroups);
        this.toggleCb(this.cbEnableDatagrouping, this.btnEnableDatagrouping, this.cbEnableDatagrouping.checked || this.cbShowEmptyGroups.checked, this.cbShowEmptyGroups.checked);

        this.onChange_showEmptyGroups();
    }

    private _setFiltersAttr(filtersArray: Array<WebcalendarTypes.WebCalendar_FilterAssignment>): void { // Array of filter ID's
        let oneFilterselected: boolean = false;

        // alle übrigend container und labels entfernen
        domAttr.set(this.filterContainer, "innerHTML", "");

        this.filterCheckboxes = [];
        // neue checkboxen hinzufügen
        for (var k = 0; k < filtersArray.length; k++) {
            var htFilter: WebcalendarTypes.WebCalendar_FilterAssignment = filtersArray[k];

            var cbContainer: HTMLElement = domConstruct.create("div", {
                style: {
                    marginBottom: "3px",
                    paddingBottom: "1px"
                },
                /*className:"w3-hide"*/
            }, this.filterContainer);

            let checkbox: HTMLElement = domConstruct.create("input", {
                type: "checkbox",
                class: "w3-check w3-hide",
                value: htFilter.ID,
                id: "filterCheckbox_" + this.filterCheckboxes.length
            }, cbContainer, "last");

            let button: HTMLElement = domConstruct.create("button", {
                className: "mds-button-base mds-hover-bright round w3-block sL4 filterButton",
                innerHTML: htFilter.ref_web_calendar_filter.description
            }, cbContainer);

            on(button, "click", lang.hitch(this, this._onClick_ToggleFilter, checkbox, button));


            if (filtersArray[k]["is_active"] && filtersArray[k]["is_active"] == true) {
                domAttr.set(checkbox, "checked", true);
                domClass.add(button, "active");
                oneFilterselected = true
            }

            on(checkbox, "change", lang.hitch(this, this._onChange_FilterCb));

            let label: HTMLElement = domConstruct.create("label",
                {
                    "innerHTML": htFilter.ref_web_calendar_filter.description,
                    "className": "filterLabel w3-hide",
                    "for": checkbox.id,
                    style: {
                        //"color": htFilter.ref_web_calendar_filter.coloration ? htFilter.ref_web_calendar_filter.coloration.BackColor.Hex : ""
                    }
                }, cbContainer);

            if (htFilter.ref_web_calendar_filter.coloration) {
                if (htFilter.ref_web_calendar_filter.coloration.BackColor.Hex != "#ffffff") {
                    let hex = htFilter.ref_web_calendar_filter.coloration.BackColor.Hex;
                    domConstruct.create("span", {
                        innerHTML: "",
                        className: "filterLabelSymbol",
                        style: "color: " + hex
                    }, label, "first");

                    let rgb = this.getRgbFromString(hex);
                    button.style.setProperty("--filterColorRgba", this.stringFormat("rgba({0},{1},{2},0.2)", rgb[0], rgb[1], rgb[2]));
                    button.style.setProperty("--filterColor", hex);
                }
            }

            this.filterCheckboxes.push(checkbox);
        }

        if (oneFilterselected == false) {
            domAttr.set(this.filterCheckboxes[0], "checked", true);
        }

        // Wenn nur ein Filter vorhanden ist, dann soll das Filterpane nicht angezeigt werden
        if (filtersArray.length > 1 || this.filterPaneHasCustomContent == true) {
            this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.filterPane);
        } else {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.filterPane);
        }

        //this.searchPanel.setActiveFilters(this.get("activeFilters"));
        this.set("loadingRequirement", "filters", 1);
    }

    private _onClick_ToggleFilter(targetCb: HTMLInputElement, targetBtn: HTMLButtonElement) {
        targetCb.checked = !targetCb.checked;

        this.UiModder.domClass.toggle(targetBtn, "active", targetCb.checked);

        this._onChange_FilterCb();
    }

    private _onChange_FilterCb() {

        let pStart: Date = this.calendar._timeInterval[0];
        let pEnd: Date = this.calendar._timeInterval[1];
        this.loadCalendarData(pStart, pEnd);

        let filters: Array<string> = this.get("activeFilters");

    //    if (filters && filters.length) {
    //        this.searchPanel.setup(filters);
    //    }
    }

    private _getActiveFiltersAttr(): Array<string> {
        var selectedFilterIds: Array<string> = [];
        arr.forEach(this.filterCheckboxes, function (checkBox: HTMLInputElement) {
            if (checkBox.checked == true) {
                selectedFilterIds.push(checkBox.value);
            }
        }, this);

        return selectedFilterIds;
    }

    setMainConfig(config: WebcalendarTypes.WebCalendarMainPropertiesConfig) {
        if (config.userProperties) {
            this.setUserPropertiesConfig(config.userProperties);
        }

        if (config.itemDetails) {
            config.itemDetails.requestUrl ? this.__itemRequestUrl = config.itemDetails.requestUrl : null;

            config.itemDetails.customFunctionName ? this.__itemRequestFunction = config.itemDetails.customFunctionName : null;

            if (typeof (config.itemDetails.customItemClickFunction) == "function") {
                this.setItemClickFunction(config.itemDetails.customItemClickFunction);
            } else {
                this.setItemClickFunction(this.openDefaultDetailView); // default
            }
        }

        if (config.resourceClickFct) {

        }

        if (typeof (config.gridDoubleClickFct) == "function") {
            this.gridDoubleClickFunction = config.gridDoubleClickFct;
        }


        if (config.filterData) {
            if (config.filterData.customFunctionName) {
                this.__filterDataFunction = config.filterData.customFunctionName;
            }
        }

        if (config.defaultDisplaySettings) {
            let dspSettings = config.defaultDisplaySettings;

            if (dspSettings.b_show_end_time === true || dspSettings.b_show_end_time === false) {
                this.__displaySettings.b_show_end_time = dspSettings.b_show_end_time;
            }

            if (dspSettings.hideColumnHead === true || dspSettings.hideColumnHead === false) {
                this.__displaySettings.hideColumnHead = dspSettings.hideColumnHead;
            }
        }

        if (config.quickSearchSettings) {
            this.setQuickSearchConfig(config.quickSearchSettings);
        }
    }

    setQuickSearchConfig(config: any) {
        this.__searchSettings = config.quickSearchSettings;
        this.hideNode(this.searchPane, this.__searchSettings);

    }

    expandPane(name: string | WebcalendarTypes.WebCalendar_DefaultPanes) {
        let node = this.getPaneNodeByName(name, true);

        if (node) {
            this._toggleSidebarSection(node, true);
        }
    }

    setItemClickFunction(callback: Function): void {
        this.itemClickFunction = callback;
    }

    loadData() {
        //?
    }

    setUserPropertiesConfig(config: WebcalendarTypes.WebCalendarUserPropertiesConfig) {
        this.__userPropConfig = config;
    }


    private _setColorationAttributesAttr(colorationAttributesArray: Array<WebcalendarTypes.WebCalendar_ColorAttribute>): void {
        //console.debug("webcalendar _setColorationAttributesAttr", colorationAttributesArray);
        domConstruct.empty(this.colorationSelectContainer);

        this.colorationAttrRegistry = []; // Array<{entity_calssname: string,  tmp_class_printname:string, colorAttributes : Array<colorAttributes>}>

        for (var colorationAttribute of colorationAttributesArray) { ////: Array<{ classname: string, ID: string, description: string, entity_classname: string, tmp_class_printname: string }>

            var objExists = false;

            for (var registryObj of this.colorationAttrRegistry) {  // Array<{entity_calssname: string,  tmp_class_printname:string, colorAttributes : Array<{ classname: string, ID: string, description: string, entity_classname: string, tmp_class_printname: string }>}>

                //prüfen ob für die entity_classname schon ein objekt existiert
                if (registryObj.entity_classname == colorationAttribute.entity_classname) {

                    objExists = true;

                    let colorIndex: number = -1;
                    for (let i = 0; i < registryObj.colorAttributes.length; i++) {
                        if (registryObj.colorAttributes[i].ID == colorationAttribute.ID) {
                            colorIndex = i;
                        }
                    }

                    if (colorIndex < 0) {
                        // wenn das colorAttr noch nicht im array ist - push
                        registryObj.colorAttributes.push(colorationAttribute);
                    } else {
                        // wenn es schon gibt (sollte nicht) - überschreiben
                        registryObj.colorAttributes[colorIndex] = colorationAttribute;
                    }
                }
            }

            if (objExists === false) {
                this.colorationAttrRegistry.push(
                    {
                        entity_classname: colorationAttribute.entity_classname,
                        tmp_class_printname: colorationAttribute.tmp_class_printname,
                        colorAttributes: Array(colorationAttribute)
                    })
            }

        }

        // Jetzt haben wir die Registry nach entity_class. 
        // Jetzt pro Klass eine Selectbox bauen

        this._createColorationSelects();
        this.set("loadingRequirement", "colorationAttributes", 1);
    }

    private _createColorationSelects(): void {
        // pro Klass eine Selectbox bauen
        if (this.colorationPaneHasCustomContent != true) {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);
        }

        let optionsCounter: number = 0;
        this._colorationSelectList = { selects: [], classNames: [] };

        if (this.colorationAttrRegistry && this.colorationAttrRegistry.length) {
            for (var j = 0; j < this.colorationAttrRegistry.length; j++) {

                var registryObj: colorAttributeRegistryObj = this.colorationAttrRegistry[j];
                let style: string = "";

                if (registryObj.colorAttributes.length > 1) { // Nur select samt Überschrift erzeugen wenn überhaupt mehr als 1 Option wählbar
                    domConstruct.create("div", {
                        "innerHTML": registryObj.tmp_class_printname,
                        className: "colorationSelectLabel"
                    }, this.colorationSelectContainer, "last");

                    let select: MdsLax<InstanceType<typeof SelectBox>> = new SelectBox();
                    select.placeAt(this.colorationSelectContainer, "last");
                    


                    for (let i = 0; i < registryObj.colorAttributes.length; i++) {
                        let colorEntry: WebcalendarTypes.WebCalendar_ColorAttribute = registryObj.colorAttributes[i];

                        select.addEntry(colorEntry.ID, colorEntry.description);

                        optionsCounter++;
                    }
                    select.constructOptions();

                    select.setValue(registryObj.colorAttributes[0].ID, true);

                    select.on("change", lang.hitch(this, function () { this._onColorationAttributeChanged(); }));

                    let value = select.getValue();

                    this._colorationSelectList.selects.push(select);
                    this._colorationSelectList.classNames.push(registryObj.entity_classname);
                }
            }
            
           
        }

        if (optionsCounter > 1) {
            if (this.userConfig.b_hide_coloration !== true) {
                this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);
            }
            this._onColorationAttributeChanged();
        } else {

            if (this.colorationAttrRegistry.length === 1) {

                var registryObj: colorAttributeRegistryObj = this.colorationAttrRegistry[0];
                let propName = registryObj.entity_classname;

                this.calendar.itemColorationAttribute[propName] = registryObj.colorAttributes[0].ID;

                this.calendar._refreshItemsRendering();
            }
        }
    }

    private _onColorationAttributeChanged(): void {
        if (!this.calendar) return;
        
        this._colorationSelectList.selects.forEach(select => {

            let selectIndex = this._colorationSelectList.selects.indexOf(select);
            let classNameOfColoration = this._colorationSelectList.classNames[selectIndex];

            this.calendar.itemColorationAttribute[classNameOfColoration] = select.getValue();
        });

        //var selectList: HTMLCollection = this.colorationSelectContainer.getElementsByClassName("colorationSelector_select");
        
        //for (var k = 0; k < selectList.length; k++) {
        //    this.calendar.itemColorationAttribute[(<HTMLInputElement>selectList[k]).dataset["entity_classname"]] = (<HTMLInputElement>selectList[k]).value

        //}

        this.calendar._refreshItemsRendering();        
    }



    // SUCHE MIT ENTITYDLG

    private _onClick_OpenSearch(evt: MouseEvent) {
        if (!this.__searchSettings) return;

        let dlg = new SelectEntityDialog();
        dlg.setConfiguration(this.__searchSettings.selectEntityDlgConfig, lang.hitch(this, this._onSelect_AppointmentInDlg));
    }

    private _onSelect_AppointmentInDlg(value?: any, items?: any) {
        console.debug("_onSelect_AppointmentInDlg", value, items);
    }

    //// Lifecycle ------------------------------START

    startup() {

        let self: any = this;
        super.startup.apply(this, arguments as any);

        setTimeout(lang.hitch(this, function () {
            if (this.loadingMessage) {
                domClass.remove(this.loadingMessage, "hide");
            }
        }), 1000);

        //this._setupSubscriptions(); // -> ist schon in Vererbung!!

        this._setupUserProperties();

        let sideBarNode = document.getElementById("sidebar_content_top");

        //this.controlContainer.style.width = document.getElementById("mySidebar").style.width; // wozu?
        domConstruct.place(this.controlContainer, sideBarNode);

        this.setTitles();

        topic.publish("/Sidebar/Pin")
        //window.sidebar.pinSidebar();
        document.getElementById("darkenOverlay").style.display = "none"; //optional, geht auch ohne, aber bissl schöner mit
    }

    setTitles(windowTitle?: string, topBar?: string) {

        if (typeof (windowTitle) == "undefined" || windowTitle == null || windowTitle == "") {
            windowTitle = this.stringFormat(this.translations["WebCalender__MainTitle"], this.translations["MainTitle"]);
        }

        if (typeof (topBar) == "undefined" || topBar == null || topBar == "") {
            topBar = this.translations["WebCalender__Title"];
        }

        let headingContainer = <HTMLDivElement>document.getElementById("mainMenuTitle");
        if (!headingContainer) headingContainer = <HTMLDivElement>document.getElementById("topBarTitle");
        if (headingContainer != null) {
            headingContainer.innerHTML = topBar;
        }
        document.title = windowTitle;

        let self: any = this;
        super.setTitles.apply(this, arguments as any);
    }

    postCreate(): void {

        let self: any = this;
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.customPanes = [];
        this.buttonsToAdd = [];

        // Synchronize date picker.		
        this.datePicker.on("change", function (e) {
            var d = self.datePicker.get("value");
            self.calendar.set("date", d);
        });

        if (typeof this.isDndEditingEnabled != "undefined") {
            this.setIsDndEditingEnabled(this.isDndEditingEnabled);
        }

        if (typeof this.itemClickFunction == "undefined") {
            this.itemClickFunction = this.openDefaultDetailView; // default
        }
    }
}

export default mdsWidget(MainProperties);